export const MILK_DONATION_OTHER_LABEL = "Other (Not Listed)";

export const MILK_DONATION_LOCATION_TO_STATE = {
    "Bronson Mothers' Milk Bank": "Michigan",
    "CHOP Mothers' Milk Bank": "Pennsylvania",
    "Henry Ford Milk Bank": "Michigan",
    "Human Milk Repository of NM": "New Mexico",
    "The King's Daughters Milk Bank": "Virginia",
    LactaLogics: "Florida",
    "It's My Leche": "Oregon",
    "The Milk Bank": "Indiana",
    "Minnesota Milk Bank for Babies": "Minnesota",
    "Mothers' Milk Bank of Alabama": "Alabama",
    "Mother's Milk Bank of Iowa": "Iowa",
    "Mother's Milk Bank of South Carolina": "South Carolina",
    "Mothers' Milk Bank - San Jose": "California",
    "Mothers' Milk Bank at Austin": "Texas",
    "Mothers' Milk Bank of Florida": "Florida",
    "Mothers' Milk Bank Mid-Atlantic": "Pennsylvania",
    "Mothers' Milk Bank Northeast": "Massachusetts",
    "Mothers' Milk Bank of Louisiana": "Louisiana",
    "Mothers' Milk Bank of Mississippi": "Mississippi",
    "Mothers' Milk Bank of North Texas": "Texas",
    "Mothers' Milk Bank of Rocky Mountain Children's Health Foundation": "Colorado",
    "Mothers' Milk Bank of Tennessee": "Tennessee",
    "Mothers' Milk Bank of the Western Great Lakes": "Illinois",
    "Mountain West Mothers' Milk Bank": "Utah",
    "The New York Milk Bank": "New York",
    "Ni-Q": "Oregon",
    "Northwest Mothers Milk Bank": "Oregon",
    "OhioHealth Mothers' Milk Bank": "Ohio",
    "Oklahoma Mothers' Milk Bank": "Oklahoma",
    "Southwest Mothers' Milk Bank": "New Mexico",
    "Tiny Treasures Milk Bank": "California",
    "UAMS Milk Bank": "Arkansas",
    "University of California Health Milk Bank": "California",
    "WakeMed Mothers' Milk Bank": "North Carolina"
};
